import * as featureFlags from './featureFlags';
import * as animationSettings from './animationSettings';
import swiperSettings from './swiperSettings';

export const HEADER_HEIGHT = 84;
export const FEATURE_FLAGS = featureFlags;
export const ANIMATION_SETTINGS = animationSettings;
export const SWIPER_SETTINGS = swiperSettings;

export const SOCIAL_LINKS = {
  INSTAGRAM: 'https://www.instagram.com/afexnigeria',
  TWITTER: 'https://twitter.com/AFEXNigeria',
  LINKED_IN: 'https://www.linkedin.com/company/afex-commodities-exchange',
  FACEBOOK: 'https://www.facebook.com/afexnigeria',
};

export const INSTAGRAM_API = {
  ENDPOINT: 'https://api.instagram.com/v1/users/self/media/recent',
  ACCESS_TOKEN: '2158065478.1677ed0.a1949a51c5904cad969a6e47a9caafdd',
  POSTS_COUNT: 32,
};

export const AFEX = {
  OLD_ADMIN_DOMAIN_NAME: 'afexnigeria.com',
  NEW_ADMIN_DOMAIN_NAME: 'blog.afexnigeria.com',
  PUBLIC_URL: 'https://afexnigeria.com',
  LOGO: 'https://storage.googleapis.com/mfalade/projects/AFEX/favicon.png',
  DISQUS_APP_NAME: 'afexnigeria',
  SERVICES_VIDEO_URL: 'https://www.youtube.com/embed/i9THS2WnWgY',
  MAILCHIMP_NEWSLETTER_URL:
    'https://afexnigeria.us7.list-manage.com/subscribe/post?u=8d2f0555e54d10dc9a2356619&amp;id=69c0634f78',
  SIGNUP_LINK: 'https://wb.afexnigeria.com/crm/client/register',
};
